import { admin } from './admin';

export const api = {
  admin
}
